<template>
  <el-dialog title="打印预览" :visible.sync="show" fullscreen :before-close="handleClose">
    <div>
      <span style="display: flex; margin-bottom: 20px;" class="dialog-footer">
        <div style="flex: 1;" />
        <el-button type="primary" @click="print">打印</el-button>
        <el-button @click="show=false">取消</el-button>
      </span>
    </div>
    <div id="printId">
      <div style="display: flex;justify-content: center;align-items: center;">
        <div>
          <div style="display: flex;">
            <div class="formItem">
              昵称
            </div>
            <div class="formItemwhite">
              {{ printData.userName }}
            </div>
            <div class="formItem">
              性别
            </div>
            <div class="formItemwhite">
              {{ printData.sexSign==1?'男':'女' }}
            </div>
          </div>
          <div style="display: flex;">
            <div class="formItem">
              年龄
            </div>
            <div class="formItemwhite">
              {{ printData.age }}
            </div>
            <div class="formItem">
              出生日期
            </div>
            <div class="formItemwhite">
              {{ printData.birthDate }}
            </div>
          </div>
          <div style="display: flex;">
            <div class="formItem">
              检查日期
            </div>
            <div class="formItemwhite">
              {{ printData.inspectTime }}
            </div>
            <div class="formItem">
              检查门店
            </div>
            <div class="formItemwhite">
              {{ printData.storeName }}
            </div>
          </div>
          <div style="display: flex;">
            <div class="formItem">
              门店地址
            </div>
            <div class="formItemwhite">
              {{ printData.contactAddress }}
            </div>
            <div class="formItem">
              联系电话
            </div>
            <div class="formItemwhite">
              {{ printData.contactPhone }}
            </div>
          </div>

        </div>
        <div class="jieguo">
          <div class="jieguo-text">
            {{ printData.inspectTypeName }}
          </div>
        </div>
      </div>

      <div style="display: flex; margin: 10px 0;">
        <div style="border-left: 5px solid #165DFF; padding:0 0 10px 10px;" />
        <div>
          指标
        </div>
      </div>
      <div>
        <div class="xueya" style="">
          <template v-for="(item, index) in inspectRecordItems">
            <div v-if="item.inspectParamName.split('-')[1]!='血糖类型'" :key="index" class="blood">
              <div style="display: flex;">
                <div class="bloodItem">
                  <img src="@/assets/icon/Vector.png" alt="">
                </div>
                <div class="bloodItem" style="font-size: 26px;">
                  {{ item.inspectValue }}
                </div>
              </div>
              <div style="display: flex;">
                <div class="bloodItem">
                  {{ item.inspectParamName.split("-")[1] }}
                </div>

              </div>
            </div>
          </template>

        </div>
        <!-- <div style="display: flex; margin-top: 10px;">
            <div style="border-left: 5px solid #165DFF; padding:0 0 10px 10px; margin-left: 10px;">

            </div>
            <div>
              指标走势
            </div>
          </div> -->
        <div class="chart-container" style="height: 300px;">
          <Charts
            ref="chartsComponent"
            :x-axis-data="xAxis"
            :legend-data="legend"
            :series-data="chartsList"
          />
        </div>
      </div>

      <div style="display: flex; margin: 10px 0;">
        <div style="border-left: 5px solid #165DFF; padding:0 0 10px 10px;" />
        <div>
          方案
        </div>
      </div>
      <div style="text-align: start; padding: 0 20px;" v-html="schemeHtml.head.htmlContent" />
    </div>
  </el-dialog>

</template>
<script>
import { getSrc } from '@/utils/ik/oss/oss.js'

import Charts from './charts.vue'
import dayjs from 'dayjs'
export default {
  components: { Charts },
  props: {
    printData: {
      type: Object,
      default: function() {
        return {}
      }
    },
    inspectRecordItems: {
      type: Array,
      default: function() {
        return []
      }
    },
    schemeList: {
      type: Array,
      default: function() {
        return []
      }
    },
    legend: {
      type: Array,
      default: function() {
        return []
      }
    },
    xAxis: {
      type: Array,
      default: function() {
        return []
      }
    },
    chartsList: {
      type: Array,
      default: function() {
        return []
      }
    },
    schemeData: {
      type: Object,
      default: function() {
        return {}
      }
    },
    schemeHtml: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      show: false,
      today: dayjs().format('YYYY-MM-DD')
    }
  },

  methods: {
    handleClose() {
      this.show = false
    },
    getsrc(url) {
      if (url) {
        return getSrc('', url)
      }
    },
    // 修改后的打印方法
    async print() {
      try {
        // 1. 获取图表图片
        const chartImg = await this.$refs.chartsComponent.exportChart()

        // 2. 克隆打印内容
        const printContent = document.getElementById('printId').cloneNode(true)

        // 3. 替换图表为静态图片
        const chartContainer = printContent.querySelector('.chart-container')
        if (chartContainer && chartImg) {
          chartContainer.innerHTML = `<img src="${chartImg}" style="width: 100%; height:250px">`
        }

        // 4. 获取所有样式（内联+外部）
        let styles = ''

        // 收集所有内联样式
        Array.from(document.querySelectorAll('style')).forEach(styleTag => {
          styles += styleTag.innerHTML + '\n'
        })

        // 收集外部样式表（仅限同源）
        const linkStyles = Array.from(document.querySelectorAll('link[rel="stylesheet"]'))
        for (const link of linkStyles) {
          if (link.href && link.href.startsWith(window.location.origin)) {
            try {
              const xhr = new XMLHttpRequest()
              xhr.open('GET', link.href, false) // 同步请求
              xhr.send()
              if (xhr.status === 200) {
                styles += xhr.responseText + '\n'
              }
            } catch (e) {
              console.error('Failed to fetch CSS: ', link.href, e)
            }
          }
        }

        // 5. 处理图片路径（解决部署后图片不显示问题）
        const images = printContent.querySelectorAll('img')
        images.forEach(img => {
          // 处理 require 动态路径的图片
          if (img.src.includes('@/assets')) {
            const imgName = img.src.split('/').pop()
            img.src = window.location.origin +
              (process.env.VUE_APP_PUBLIC_PATH || '/') +
              'img/' + imgName
          }
          // 添加打印专用样式

          img.style.pageBreakInside = 'avoid'
        })

        // 6. 创建打印窗口并注入完整样式
        const printWindow = window.open('', '_blank')
        printWindow.document.write(`
          <!DOCTYPE html>
          <html>
            <head>
              <title>打印视图</title>
              <style>
                /* 注入所有原始样式 */
                ${styles}
                
                /* 强制打印样式 */
                @media print {
                  body {
                    margin: 0 !important;
                    padding: 10mm !important;
                    -webkit-print-color-adjust: exact !important;
                    print-color-adjust: exact !important;
                  }
                  .formItem {
                    background: #F2F3F5 !important;
                    border: 1px solid #E5E6EB !important;
                    min-height: 35px !important;
                    font-size: 12px !important;
                    padding: 3px 8px !important;
                  }
                  .formItemwhite {
                    background: #FFFFFF !important;
                    border: 1px solid #E5E6EB !important;
                  }
                  .dialog-footer, .el-dialog__header {
                    display: none !important;
                  }
                  .xueya {
                    background: #DEEEFC !important;
                  }
                  .blood {
                    background: #fff !important;
                  }
                  .jieguo {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    background-size: contain !important;
    min-height: 120px !important;
    min-width: 150px !important;
  }
  
  .jieguo-text {
    text-shadow: none !important;
    font-size: 12pt !important; /* 打印时使用点单位 */
  }
                  img {
                    max-width: 100% !important;
                    page-break-inside: avoid !important;
                  }
                  #printId > div {
                    break-inside: avoid;
                  }
                }
                
                /* 非打印时的预览样式 */
                @media screen {
                  body { 
                    background: #f0f2f5; 
                    padding: 20px;
                  }
                  #printContent {
                    max-width: 800px;
                    margin: 0 auto;
                    background: white;
                    box-shadow: 0 0 10px rgba(0,0,0,0.1);
                    padding: 20px;
                  }
                }
              </style>
            </head>
            <body>
              <div id="printContent">
                ${printContent.innerHTML}
              </div>
              <script>
                window.onload = function() {
                  window.print()
                  setTimeout(function() {
                    window.close()
                  }, 500)
                }
              <\/script>
            </body>
          </html>
        `)
        printWindow.document.close()
      } catch (error) {
        console.error('打印失败:', error)
        this.$message.error('打印失败，请检查控制台')
      }
    }

  }
}
</script>

<style lang="scss" scoped>
.formItem {
    width: 140px;
    background: #F2F3F5;
    border: 1px solid #E5E6EB;
    height: 40px;
    display: flex;
    align-items: center;
    padding-left: 10px;
}

.mainPhy {
    display: flex;
    align-items: center;
    border: 1px solid #E5E9EF;
    width: 280px;
    padding: 5px;
}

.blood {
    background: #fff;
    height: 60px;
    width: 150px;
    padding-top: 5px;
    margin: 0 30px;
}

.bloodItem {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.xueya {
    background: #DEEEFC;
    height: 132px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 20px;
}
.formItemwhite{
  width: 140px;
  border: 1px solid #E5E6EB;
  height: 40px;
  display: flex;
  align-items: center;
  padding-left: 10px;
  background: #FFFFFF;
}
.chart-container{
  margin-top: 20px;
}
.jieguo-text{
  transform: rotate(-30deg);
  color: rgb(17, 10, 224);
}
.jieguo{
  background-image: url('../../../../assets/health/jieguo.png');
  background-position: center;
  background-repeat: no-repeat;
  height: 120px;
  width: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
